"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertHealthCheckFromJsonToXml = void 0;
const fast_xml_parser_1 = require("fast-xml-parser");
const convertHealthCheckFromJsonToXml = (params) => {
    const builder = new fast_xml_parser_1.XMLBuilder({ ignoreAttributes: false });
    const input = {
        HealthCheck: {
            Credentials: params.credentials,
            Application: params.application,
            '@_xmlns': 'https://transaction.elementexpress.com',
        },
    };
    const xml = builder.build(input);
    return xml;
};
exports.convertHealthCheckFromJsonToXml = convertHealthCheckFromJsonToXml;
//# sourceMappingURL=convertHealthCheckFromJsonToXml.js.map